import React from "react"

// Internals
import "./_style.scss"

// Assets
import PlusIcon from "§/src/images/svg/plus.svg"

const AccordionGroupItemPeople = ({
  parentindex,
  itemindex,
  title,
  content,
  children,
	onClick,
  ...props
}) => {
  const compClassName = "accordion-group-item"
  const compClass =
    props?.className !== undefined
      ? compClassName + " " + props?.className
      : compClassName


  return (
    <div comp={compClassName} className={compClass} key={itemindex}>
      <h2 className="accordion-header h5" id={"flush-heading-" + itemindex}>
        <button
          className={
            "accordion-button " + (itemindex === "item-0" ? "" : "collapsed")
          }
          type="button"
          aria-expanded={itemindex === "item-0" ? "true" : "false"}
          data-bs-toggle="collapse"
          data-bs-target={"#" + itemindex}
          aria-controls={itemindex}
					onClick={onClick}
        >
          <div className="d-flex flex-column gap-1 py-3">
            <p className="fs-20 title m-0">{title}</p>
            {content && <p className="fs-16 content m-0">{content}</p>}
          </div>
          <div className="accordion-button-icon">
            <i className="rounded-circle">
              <PlusIcon></PlusIcon>
            </i>
          </div>
        </button>
      </h2>
      <div
        id={itemindex}
        className={
          "accordion-collapse " + (itemindex === "item-0" ? "show" : "collapse")
        }
        aria-labelledby={"flush-heading-" + itemindex}
        data-bs-parent={"#" + parentindex}
      >
        <div className="accordion-body">
          <div className="inner">
            <div className="row justify-content-end">
              <div className="d-none d-xl-block col-lg-3"></div>
              <div className="col col-md-12 col-lg-9">{children}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccordionGroupItemPeople
